export const VALIDATED_ELEMENTS_NAMES = {
    phone: 'phone',
    phone2: 'phone2'
};
